module.exports = __webpack_public_path__ + "44d198be5b53e1becab1a5c280f97f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Oval.png
// module id = 780
// module chunks = 0